<template>
  <modal-dialog
    visible
    persistent
  >
    <v-container
      fluid
      class="d-flex align-center flex-column"
    >
      <p class="text-body-1">
        {{ $t('message.prompt_delete_account') }}
      </p>
      <v-text-field
        ref="deleteField"
        v-model="deleteConfirmText"
        :label="$t('message.type_delete_account')"
        class="pt-3"
        outlined
      />
      <div class="w-100">
        <v-divider class="py-1 my-0" />
      </div>
      <p class="pt-2 py-0 my-0">
        {{ $t('message.provide_delete_account_reason') }}
      </p>
      <v-radio-group
        v-model="reason"
        class="pa-0 ma-0 pt-1"
      >
        <v-radio
          :value="0"
          :label="$t('label.delete_reason_1')"
        />
        <v-radio
          :value="1"
          :label="$t('label.delete_reason_2')"
        />
        <v-radio
          :value="2"
          :label="$t('label.delete_reason_3')"
        />
        <v-radio
          :value="3"
          :label="$t('label.delete_reason_4')"
        />
        <div class="d-flex">
          <v-radio :value="4" />
          <v-text-field
            v-model="otherReason"
            class="pt-0 mt-0"
            :placeholder="$t('label.reason_other')"
            dense
            hide-details
            @click="reason=4"
          />
        </div>
      </v-radio-group>
    </v-container>
    <template #actions>
      <v-spacer />
      <v-btn
        color="error"
        :disabled="!deleteEnabled"
        @click="deleteAccount"
      >
        {{ $t('button.delete_account') }}
      </v-btn>
      <v-btn
        text
        @click="$emit('close')"
      >
        {{ $t('button.close') }}
      </v-btn>
    </template>
  </modal-dialog>
</template>

<script setup lang="ts">
import Vue, { computed, onMounted, ref } from 'vue';
import { performAction } from '@/services/vue-utils';
import i18n from '@/plugins/i18n';
import store from '@/store/store';
import { useVuetify } from '@/components/helpers/vue2-helpers';
import router from '@/router';

const vuetify = useVuetify();

const deleteFieldRef = ref<HTMLElement>();

const deleteConfirmText = ref('');

const reason = ref(undefined as number | undefined);
const otherReason = ref('');

const deleteEnabled = computed(() => deleteConfirmText.value.toUpperCase() === 'DELETE' && reason.value !== undefined);

onMounted(() => {
  setTimeout(() => {
    deleteFieldRef.value?.focus();
  }, 300);
});

const deleteAccount = async () => {
  const reasonIndex = reason.value ?? 4;
  const reasonText = reasonIndex === 4
    ? otherReason.value || i18n.tc('label.delete_reason_other')
    : i18n.tc(`label.delete_reason_${reasonIndex + 1}`);

  const ok = await performAction(
    i18n.tc('message.success_delete_account'),
    i18n.tc('error.deleting_account'),
    async () => store.dispatch('deleteAccount', { reasonText }),
  );

  if (!ok) return;

  vuetify.theme.dark = false;
  router.push('/login');
};

</script>
